/**
 * Norwegian Bokmål Translations
 * All user-facing strings in Norwegian Bokmål
 */

export default {
    cart: {
        empty: 'Ingen produkter funnet',
        selectQuantity: 'Velg antall:',
        title: 'Handlekurv',
        close: 'Lukk handlekurven',
        toCheckout: 'Til kassen',
        done: 'Ferdig',
        editCart: 'Endre handlekurv',
        emptyCart: 'Tøm handlekurven',
        total: 'Totalt',
        goodsTotalExcl: 'Varer (ekskl. frakt og rabatt)',
        giftCard: {
            to: 'Til:',
            from: 'Fra:',
            message: 'Melding:',
            physical: 'Fysisk kort:',
            deliveryAddress: 'Leveringsadresse:',
            yes: 'Ja'
        }
    },
    discount: {
        apply: 'Bruk rabattkode',
        remove: 'Fjern',
        validating: 'Validerer rabattkode...',
        invalid: 'Ugyldig rabattkode',
        error: 'En feil oppsto ved validering av rabattkoden. Prøv igjen.',
        alreadyApplied: 'Rabattkode allerede brukt',
        applied: 'Rabattkode brukt!',
        removed: 'Rabattkode fjernet',
        placeholder: 'Skriv inn rabattkode',
        enterCode: 'Skriv inn en rabattkode',
        noManualDiscount: 'Ingen manuell rabattkode å fjerne'
    },
    shipping: {
        loading: 'Laster leveringsalternativer...',
        error: 'Kunne ikke laste leveringsalternativer. Prøv igjen.',
        retry: 'Prøv igjen',
        free: 'Gratis',
        noOptions: 'Ingen leveringsalternativer tilgjengelig for øyeblikket.',
        contactSupport: 'Kontakt kundeservice for hjelp.',
        selectRequired: 'Vennligst velg et leveringsalternativ',
        methods: {
            PickUpStore: 'Hent i butikk',
            Home: 'Hjemlevering',
            BoxReg: 'Boks (registrert)',
            BoxUnreg: 'Boks (uregistrert)',
            PickUpPoint: 'Hentested',
            Own: 'Egen levering',
            Postal: 'Postkontor',
            DHLPackstation: 'DHL Pakkestasjon',
            Digital: 'Digital levering'
        }
    },
    checkout: {
        emptyCart: 'Ingen produkter i handlekurven',
        fillRequired: 'Vennligst fyll ut alle obligatoriske felt og godta vilkårene.',
        paymentError: 'Betaling feilet. Prøv igjen.',
        paymentCancelled: 'Betalingen ble avbrutt eller feilet.',
        processing: 'Behandler...',
        placeOrder: 'Legg bestilling',
        error: 'En feil oppsto under checkout. Prøv igjen.',
        noItems: 'Ingen varer i handlekurven',
        noCheckoutUrl: 'Ingen checkout-URL mottatt fra betalingsleverandøren',
        initiateFailed: 'Kunne ikke initiere betaling. Prøv igjen.'
    },
    giftCardPayment: {
        apply: 'Bruk gavekort',
        remove: 'Fjern',
        validating: 'Validerer gavekort...',
        invalid: 'Gavekortet kunne ikke brukes. Kontroller kortnummer og PIN-kode.',
        error: 'En feil oppsto ved validering av gavekortet. Prøv igjen.',
        enterCard: 'Oppgi kortnummer og PIN-kode',
        removed: 'Gavekort fjernet',
        balanceLabel: 'saldo',
        fullCoverageInfo: 'Gavekortet dekker hele ordren – ingen kortbetaling er nødvendig.',
        partialNotSupported: 'Gavekortet dekker ikke hele ordren og kan ikke kombineres med denne betalingsmåten. Fjern gavekortet for å fortsette.'
    },
    common: {
        subtotal: 'Delsum',
        shipping: 'Frakt',
        discount: 'Rabatt',
        total: 'Totalt',
        yes: 'Ja',
        no: 'Nei',
        loading: 'Laster...',
        error: 'En feil oppsto',
        tryAgain: 'Prøv igjen'
    },
    giftCard: {
        defaultName: 'Gavekort',
        addedToCart: 'Lagt til i handlekurven!',
        validation: {
            recipientNameRequired: 'Mottakerens navn er påkrevd',
            nameTooShort: 'Navnet må være minst 2 tegn',
            emailRequired: 'E-postadresse er påkrevd for digitale gavekort',
            emailInvalid: 'Vennligst oppgi en gyldig e-postadresse',
            senderNameRequired: 'Avsenderens navn er påkrevd',
            deliveryNameRequired: 'Fornavn er påkrevd for fysiske kort',
            deliveryLastnameRequired: 'Etternavn er påkrevd for fysiske kort',
            deliveryAddressRequired: 'Adresse er påkrevd for fysiske kort',
            addressTooShort: 'Adressen må være minst 5 tegn',
            deliveryZipRequired: 'Postnummer er påkrevd for fysiske kort',
            zipInvalid: 'Postnummer må være 5 siffer',
            deliveryCityRequired: 'By er påkrevd for fysiske kort',
            cityTooShort: 'By må være minst 2 tegn'
        },
        errors: {
            noProductId: 'Kunne ikke bestemme produkt-ID',
            addToCartFailed: 'En feil oppsto ved å legge gavekortet i handlekurven'
        }
    }
};
